module.exports = __webpack_public_path__ + "img/D8388B_230A14_FCC8FC_FC71E1-256px.cbb13235.png";